import axios from 'axios';
import { ChatRequest, ChatResponse, Event, DegreePlan, UserProfile } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const chatAPI = {
  sendMessage: async (request: ChatRequest): Promise<ChatResponse> => {
    const response = await api.post<ChatResponse>('/api/chat', request);
    return response.data;
  },

  healthCheck: async () => {
    const response = await api.get('/api/health');
    return response.data;
  },

  getIndexStats: async () => {
    const response = await api.get('/api/index/stats');
    return response.data;
  },
};

export const eventsAPI = {
  getEvents: async (params?: { start_date?: string; end_date?: string; event_type?: string }) => {
    const response = await api.get('/api/events', { params });
    return response.data;
  },

  getThisWeekEvents: async () => {
    const response = await api.get('/api/events/this-week');
    return response.data;
  },

  getUpcomingEvents: async (limit?: number) => {
    const response = await api.get('/api/events/upcoming', { params: { limit } });
    return response.data;
  },
};

export const degreePlanAPI = {
  generatePlan: async (userProfile: UserProfile) => {
    const response = await api.post('/api/degree-plan/generate', { user_profile: userProfile });
    return response.data;
  },

  savePlan: async (userId: string, planData: any) => {
    const response = await api.post('/api/degree-plan/save', { user_id: userId, plan_data: planData });
    return response.data;
  },

  getPlan: async (planId: string) => {
    const response = await api.get(`/api/degree-plan/${planId}`);
    return response.data;
  },

  getUserPlans: async (userId: string) => {
    const response = await api.get(`/api/user/${userId}/degree-plans`);
    return response.data;
  },
};

export const userAPI = {
  saveProfile: async (userId: string, profile: UserProfile) => {
    const response = await api.post('/api/user/profile', { user_id: userId, profile });
    return response.data;
  },

  getProfile: async (userId: string) => {
    const response = await api.get(`/api/user/${userId}/profile`);
    return response.data;
  },
};

export default api;
